import { cn } from "./cn";

/* The two green panel treatments, and only those two. Both carry the grain
   overlay — it is what stops the gradient banding, so it is not optional.
   On these, type goes light and buttons go `white` / `onDeep`. */

const GROUNDS = {
  cta: "bg-cta",   // linear-gradient(#74C0AB, #216351 50%, #216351)
  deep: "bg-deep", // linear-gradient(#216351, #0D3026)
};

const Panel = ({ ground = "deep", className, children, ...props }) => (
  <div className={cn("relative overflow-hidden rounded-ns", GROUNDS[ground], className)} {...props}>
    <span
      aria-hidden="true"
      className="pointer-events-none absolute inset-0 bg-grain mix-blend-overlay"
      style={{ opacity: "var(--ns-grain-opacity)" }}
    />
    <div className="relative">{children}</div>
  </div>
);

export default Panel;
